// eslint-disable-next-line @typescript-eslint/no-unused-vars
import React from 'react';
import { IHeaderGroupParams, IHeaderParams } from 'ag-grid-community';
import styles from './AutoGroupHeaderComponent.scss';

export function AutoGroupHeaderComponent({ displayName }: Partial<IHeaderGroupParams & IHeaderParams>) {
  return (
    <div className={styles.container} role="presentation">
      <span className={styles.text} aria-label={displayName} />
    </div>
  );
}
